module.exports = __webpack_public_path__ + "static/header-iphone-trouverty-b0c67bbbf16551d7fac57c0e60cee380.png";